<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getDataSources">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addDataSources">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="dataSources" highlight-current-row v-loading="listLoading" style="width: 100%;" :height="bodyHeight-220">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="dataSourceType" label="数据源类型" min-width="100">
      </el-table-column>
      <el-table-column prop="server" label="服务器" min-width="150">
      </el-table-column>
      <el-table-column prop="user" label="用户名" min-width="100">
      </el-table-column>
      <el-table-column label="密码" min-width="100">
        ********
      </el-table-column>
      <el-table-column prop="database" label="数据库" min-width="200">
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template scope="scope">
          <el-button type="danger" size="small" @click="delDataSource(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog title="数据源新增" :visible.sync="addFormVisible" :close-on-click-modal="false" top="5vh" width="80%">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <el-form-item label="数据源类型" prop="dataSourceType">
          <el-select v-model="addForm.dataSourceType" placeholder="请选择">
            <el-option value="SQL Server"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务器" prop="server">
          <el-input v-model="addForm.server"></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="user">
          <el-input v-model="addForm.user"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="数据库" prop="databases">
          <el-transfer v-model="addForm.databases"
                       :props="{
                          key: 'value',
                          label: 'desc'
                        }"
                       :titles="['未选', '已选']"
                       :data="databases">
            <el-button class="transfer-footer" slot="left-footer" size="small" :loading="dbLoading" @click="getDatabases">加载数据库</el-button>
          </el-transfer>
          <!--<el-select v-model="addForm.databases" multiple placeholder="请选择数据库" @visible-change="getDatabases">
            <el-option v-for="item in databases"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>-->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveDataSource" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<style>
  i.Success {
    color: #67C23A
  }
  i.Info {
    color: #909399
  }
</style>

<script>
export default {
  name: 'datasourcemanage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      sels: [],
      listLoading: false,
      sortname: 'dataSourceId',
      sorttype: 'ascending',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      dataSources: [],
      databases: [],
      selectddatabases: [],
      addFormVisible: false,
      addLoading: false,
      dbLoading:false,
      addFormRules: {
        dataSourceType: [
          { required: true, message: '请输入数据源类型', trigger: 'blur' }
        ],
        server: [
          { required: true, message: '请输入服务器名', trigger: 'blur' }
        ],
        user: [
          { required: true, message: '请输入登录名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        databases: [
          { required: true, message: '请选择数据库', trigger: 'blur' }
        ]
      },
      addForm: {
        dataSourceType: "",
        server: "",
        user: "",
        password: "",
        databases: []
      }

    }
  },
    methods: {
    // 获取列表
    getDataSources: function () {
      let para = {
        agentId: this.$route.params.agentId,
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }
      this.$ajax({
        url: 'api/DataCollect/GetDataSources',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.dataSources = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    
    pageChange: function(val) {
      this.pageno = val
      this.getDataSources()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getDataSources()
    },
    // 删除数据源
    delDataSource: function (index,row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        this.$ajax({
          loadingName: "listLoading",
          url: `api/DataCollect/DeleteDataSource?dataSourceId=${row.dataSourceId}`
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getDataSources()
        })
      }).catch(() => {
      })
      }
      ,
    addDataSources: function () {
      this.addFormVisible = true
      this.addForm = {
        agentId: this.$route.params.agentId,
        dataSourceType: "SQL Server",
        server: "",
        user: "",
        password: "",
        databases: []
      }
      this.$refs.addForm.resetFields()
    },
    saveDataSource: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.databases = this.addForm.databases.filter(v => !this.selectddatabases.find((item) => item === v));
          let para = Object.assign({}, this.addForm)
          this.$ajax({
            url: 'api/DataCollect/AddDataSource',
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.$refs['addForm'].resetFields()
              this.addFormVisible = false
              this.getDataSources()
            }
          })
        }
      })
    },
    getDatabases: function (v) {
      if (v) {
        this.databases= [] 
        let para = {
          agentId: this.$route.params.agentId,
          server: this.addForm.server,
          user: this.addForm.user,
          password: this.addForm.password
        }
        this.$ajax({
          url: 'api/DataCollect/GetDatabases',
          method: 'post',
          data: JSON.stringify(para),
          loadingName: 'dbLoading',
          success: (d, r) => {
            for (let i = 0; i <= d.length - 1; i++) {
              this.databases.push({
                value: d[i],
                desc: d[i]
              });
            }
          }
        }).then(() => {
          let para = {
            agentId: this.$route.params.agentId,
            keywords: '',
            pageno: 1,
            pagesize: 500,
            sortname: '',
            sorttype: 'asc'
          }
          this.$ajax({
            url: 'api/DataCollect/GetDataSources',
            method: 'get',
            data: para,
            loadingName: 'dbLoading',
            success: (d, r) => {
              let dd = [];
              d.forEach((i) => { dd.push(i.database); });
              this.selectddatabases = dd;
              this.addForm.databases = [...dd];
            }
          })
        })
      }
    }
  },
  mounted() {
    this.getDataSources()
  }
}
</script>